import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducer";
import rootSaga from "./saga";

import createSagaMiddleware from "redux-saga";
import createLogger from "redux-logger";

import { composeWithDevTools } from "redux-devtools-extension";

import { routerMiddleware } from "./middlewares/router_middleware";

const composeEnhancers = composeWithDevTools({
  name: "RetailerReporting"
});

const configureStore = (history) => (preloadedState) => {
  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(
      applyMiddleware(sagaMiddleware, createLogger(), routerMiddleware(history))
    )
  );

  sagaMiddleware.run(rootSaga);
  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./client/store.js